import { IsNotEmpty, IsString, IsOptional, IsArray, MaxLength, MinLength } from 'class-validator';
import { TeamAccessEditDTO } from '../team/team-access-edit.dto';

export class ProductCheckpointQuestionEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    question: string;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    checkpoints: Array<string>;

}
